import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PresentApi } from 'api';
import type { Present } from 'api/methods/PresentApi';

/**
 * [Present] Query key 생성
 * --
 */
export const presentQueryKeys = createQueryKeys('present', {
  getPresent: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getPresents: (params?: { [key: string]: string | number }) => [params],
  getPresentGuest: (params?: { [key: string]: string | number }) => [
    'guest',
    params,
  ],
});

/**
 * [Present] 선물 전체 조회
 * --
 */
export const useGetPresents = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: presentQueryKeys.getPresents(params).queryKey,
    queryFn: () => PresentApi.getPresents(params),
    ...options,
  });
  return data;
};

/**
 * [Present] 선물 상세 조회
 * --
 */
export const useGetPresent = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: presentQueryKeys.getPresent(idx, params).queryKey,
    queryFn: () => PresentApi.getPresent(idx, params),
  });

  return data;
};

/**
 * [Present] 선물 생성
 * --
 */
export const useCreatePresent = (body: Present) => {
  const { mutateAsync: createPresent, ...result } = useMutation({
    mutationFn: (variables: Present) => PresentApi.createPresent(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createPresent, ...result };
};

/**
 * [Present] 선물 수정
 * --
 */
export const useUpdatePresent = () => {
  const { mutateAsync: updatePresent, ...result } = useMutation({
    mutationFn: (variables: Present) => PresentApi.updatePresent(variables),
  });

  return { updatePresent, ...result };
};
/**
 * [Present] 금액권 사용
 */
export const useUpdateAmountPresent = () => {
  const { mutateAsync: updateAmountPresent, ...result } = useMutation({
    mutationFn: (variables: Present) =>
      PresentApi.updateAmountPresent(variables),
  });

  return { updateAmountPresent, ...result };
};
/**
 * [Present] 선물 삭제
 * --
 */
export const useDeletePresent = (idx: number) => {
  const { mutateAsync: deletePresent, ...result } = useMutation({
    mutationFn: (variables: number) => PresentApi.deletePresent(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deletePresent, ...result };
};

/**
 * [Present] 선물 생성
 * --
 */
export const useSendPresent = (body: Present) => {
  const { mutateAsync: sendPresent, ...result } = useMutation({
    mutationFn: (variables: Present) => PresentApi.sendPresent(variables),
  });

  return { sendPresent, ...result };
};

/**
 * [Present] 선물 게스트 전체 조회
 * --
 */
export const useGetPresentGuest = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: presentQueryKeys.getPresentGuest(params).queryKey,
    queryFn: () => PresentApi.getPresentGuest(params),
    ...options,
  });
  return data;
};
/**
 * [Present] 선물 결제 취소
 * --
 */
export const useCancelPresent = (body: Present) => {
  const { mutateAsync: cancelPresent, ...result } = useMutation({
    mutationFn: (variables: Present) => PresentApi.cancelPresent(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { cancelPresent, ...result };
};
